import { render, staticRenderFns } from "./OrderTax.vue?vue&type=template&id=e7883a84&scoped=true"
import script from "./OrderTax.vue?vue&type=script&lang=js"
export * from "./OrderTax.vue?vue&type=script&lang=js"
import style0 from "./OrderTax.vue?vue&type=style&index=0&id=e7883a84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7883a84",
  null
  
)

export default component.exports